import type React from "react";
import {
  type WorkflowStepUserResponse,
  WorkflowStepUserResponses,
} from "~/api/types";
import { cn } from "~/lib/utils";
import { Badge } from "~/atoms/badge";
import { ActionIndicator } from "./StepUserActionIndicator";

interface WorkflowStepBadgeProps {
  response: WorkflowStepUserResponse;
  isActive: boolean;
  additionalClasses?: string;
  children: React.ReactNode;
}

export function WorkflowStepBadge({
  response,
  isActive,
  additionalClasses,
  children,
}: WorkflowStepBadgeProps) {
  const badgeClassName = cn(
    "flex items-center gap-2 h-auto text-xs",
    {
      "border-warning/30 bg-warning/4":
        isActive && response === WorkflowStepUserResponses.pending,
      "border-destructive/30 bg-destructive/4":
        response === WorkflowStepUserResponses.rejected,
      "border-success/30 bg-success/4":
        response === WorkflowStepUserResponses.approved,
    },
    additionalClasses,
  );

  return (
    <div className="bg-card rounded-4xl">
      <Badge className={badgeClassName} variant="secondary">
        {children}
        <ActionIndicator response={response} />
      </Badge>
    </div>
  );
}
